import { type LoggedUserData } from "@acme/types";
import { create } from "zustand";

import { type SubscriptionStatus } from "~/app/_actions/subscription";
import { type UserAccess } from "~/app/_actions/user";

type Store = {
  currentAccess: UserAccess | null;
  /// Every org/partner the user can switch into. Populated by InitializeState
  /// from the same retrieveUserAccess() call that sets currentAccess, so the
  /// switcher does not have to re-fetch it.
  accessList: UserAccess[];
  loggedUser: LoggedUserData | null;
  subscriptionStatus: SubscriptionStatus | null;
  setAccess: (access: UserAccess) => void;
  setAccessList: (accessList: UserAccess[]) => void;
  setLoggedUser: (user: LoggedUserData | null) => void;
  setSubscriptionStatus: (status: SubscriptionStatus) => void;
};

export const useStore = create<Store>((set) => ({
  currentAccess: null,
  setAccess: (access) => set({ currentAccess: access }),
  accessList: [],
  setAccessList: (accessList) => set({ accessList }),
  loggedUser: null,
  setLoggedUser: (user) => set({ loggedUser: user }),
  subscriptionStatus: null,
  setSubscriptionStatus: (status) => set({ subscriptionStatus: status }),
}));
